module.exports = __webpack_public_path__ + "img/homecat-right1.70381c8a.png";